import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { IDiscountedTransactionsApiService } from './discounted-transactions-api.interface';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import { IDiscountedTransaction } from '../../../../model/discounted-transaction';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { toDiscountTransactionDirectionDtoMapper } from '../../../mapper/discounted-transaction.mapper';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { SnackbarService } from '../../../../shared/services/snackbar.service';
import { ANALYTICS_API_URL } from '../../accounting/accounting-analytics-api.constants';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportDiscountedTransactionsQueryDto } from './dtos/export-discounted-transactions.query.dto';
import { FindDiscountedTransactionsQueryDto } from './dtos/find-discounted-transactions.query.dto';
import { FindDiscountedTransactionsResponseDto } from './dtos/find-discounted-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class DiscountedTransactionsApiService
  implements IDiscountedTransactionsApiService
{
  private readonly ENDPOINT = 'discount-transactions';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findDiscountedTransactions(
    query: FindDiscountedTransactionsQueryDto
  ): Promise<FindDiscountedTransactionsResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindDiscountedTransactionsResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportDiscountedTransactions(
    query: ExportDiscountedTransactionsQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
